<template>
  <div class="main">
    <div class="main-top">
      <img src="../assets/img/main-title.jpg" alt="" />
    </div>
    <div class="main-content">
      <div class="main-title">
        <h1>公司简介</h1>
      </div>
      <div class="main-summary">
        <div class="summary-img">
          <img src="../assets/img/summaryimg.png" alt="" />
        </div>
        <div class="summary-text">
          <p>
            西安伟普通信技术有限公司成立于2016年6月，注册资金1000万元，是国家高新技术企业、科技型中小企业，已通过ISO9001质量管理体系、ISO14001环境管理体系、ISO45001职业健康安全管理体系三项认证。公司是聚焦通信基础设施配套领域的综合科技企业，核心业务覆盖通信设备、通信电源、能耗管理、预警管理等相关产品的研发、销售、安装与全周期维护，在谷电峰用、开关电源管理、能耗智能管控、安全预警管理等方向拥有多项自主专利和软件著作权，具备完全自主的技术研发与落地交付能力。成立至今，公司已为中国铁塔、中国电信、中国移动、中国联通等头部通信行业客户提供了稳定的产品与技术服务，同时也和其他通信相关企业建立了长期合作关系。公司始终秉承“品质赢得认同，服务创造价值，创新推动发展”的经营理念，以“深刻理解客户需求，服务创造价值”为核心服务宗旨，持续为客户输出专业化的技术服务与高可靠性产品，致力于打造成为通信行业内专业化、值得客户深度信赖的优质服务商。
          </p>
        </div>
      </div>
      <div class="main-title">
        <h1>产品服务</h1>
      </div>
      <div class="main-prodserv">
        <div class="prod" @click="openWindow('alarm')">
          <div class="prod-img" style="border-bottom: 2px solid #c4382d">
            <img src="../assets/img/basestation.png" alt="" />
          </div>
          <div class="prod-name">
            <font>通信基站隐患管理系统</font>
          </div>
          <div class="prod-desc">
            蓄电池单体实时检测分析 蓄电池充放电单体均衡
            隐患排查、智能预警、科学调度 有效延长蓄电池使用寿命
            显著减少电源故障及维护成本
          </div>
        </div>
        <div class="prod">
          <div class="prod-img" style="border-bottom: 2px solid #9abf43">
            <img src="../assets/img/money.png" alt="" />
          </div>
          <div class="prod-name">
            <font>资产管理系统</font>
          </div>
          <div class="prod-desc">
            采集电源设备实时数据、基站基础数据，结合历史数据和故障记录深度挖掘，智能分析出基站电源设备隐患，并输出维修及调度指引，实现智能主动预警、科学调度
          </div>
        </div>
        <div class="prod"  @click="openWindow('ebms')">
          <div class="prod-img" style="border-bottom: 2px solid #e69a37">
            <img src="../assets/img/manage.png" alt="" />
          </div>
          <div class="prod-name">
            <font>EBMS管理系统</font>
          </div>
          <div class="prod-desc">
            以实物+二维码+图片管理为特点，以电脑端+手机端为操作平台，以“快捷”、“精准”和功能全面为优势的资产管理系统。系统采用B/S结构，分布式数据库。该系统通过先进的条形码技术对资产实物
          </div>
        </div>
        <div class="prod">
          <div class="prod-img" style="border-bottom: 2px solid #2c6eb2">
            <img src="../assets/img/robot.png" alt="" />
          </div>
          <div class="prod-name">
            <font>巡检机器人</font>
          </div>
          <div class="prod-desc">
            搭载视频设备和多种传感器，沿轨道对基站设备进行自动巡检，能够实现基站设备全方位、全自主智能巡检和监控；可有效降低设备维护成本，为通信基站和无人值守站提供新型的技术巡检手段和更可靠的安全保障。
          </div>
        </div>
      </div>
      <div class="main-title">
        <h1>专利软著</h1>
      </div>
      <div class="main-patent">
        <el-image
          v-for="item in patentList"
          :key="item"
          style="margin: 0 1vw; width: 14vw; height: auto"
          :src="item"
          :preview-src-list="patentList"
        >
        </el-image>
      </div>
      <div class="main-book">
        <el-image
          v-for="item in bookList"
          :key="item"
          style="width: 14vw; height: 100%"
          :src="item"
          :preview-src-list="bookList"
        >
        </el-image>
      </div>
      <div class="main-title">
        <h1>资质证书</h1>
      </div>
      <div class="main-cert">
        <el-image
          v-for="item in certList"
          :key="item"
          style="margin: 3vh 2vw; width: 10vw; height: auto"
          :src="item"
          :preview-src-list="certList"
        >
        </el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      patentList: [
        require("../assets/img/1-1.jpg"),
        require("../assets/img/1-2.jpg"),
        require("../assets/img/1-3.jpg"),
      ],
      certList: [
        require("../assets/img/2-1.jpg"),
        require("../assets/img/2-2.jpg"),
        require("../assets/img/2-3.jpg"),
        require("../assets/img/2-4.jpg"),
        require("../assets/img/2-5.jpg"),
        require("../assets/img/2-6.jpg"),
      ],
      bookList: [
        require("../assets/img/3-1.jpg"),
        require("../assets/img/3-2.jpg"),
        require("../assets/img/3-3.jpg"),
        require("../assets/img/3-4.jpg"),
        require("../assets/img/3-5.jpg"),
        require("../assets/img/3-6.jpg"),
        require("../assets/img/3-7.jpg"),
        require("../assets/img/3-8.jpg"),
        require("../assets/img/3-9.jpg"),
        require("../assets/img/3-10.jpg"),
        require("../assets/img/3-11.jpg"),
      ],
      map: {},
    };
  },
  mounted() {},
  methods: {
    openWindow(v) {
      switch (v) {
        case "alarm":
          window.open("http://weipucomm.cn:8080/");
          break;
        case "ebms":
          window.open("http://weipucomm.cn:8066/");
          break;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.main {
  background-color: #f7f7f7;
  .main-top {
    margin: 1vh 0 0 0;
    height: 13vh;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .main-content {
    margin: 0 5vw;
    .main-title {
      border-bottom: 1px solid #ecedf1;
      overflow: hidden;
      height: 100px;
      h1 {
        background: url(../assets/img/red-line.png) no-repeat center bottom;
        font-weight: 700;
        width: 160px;
        line-height: 100px;
        margin: 0;
      }
    }
    .main-summary {
      display: flex;
      align-items: center;
      .summary-img {
        padding: 5vh 0;
        width: 30vw;
        img {
          width: 100%;
          height: auto;
        }
      }
      .summary-text {
        padding: 0 0 0 2vw;
        flex: 1;
        p {
          text-indent: 28px;
          line-height: 36px;
          font-size: 16px;
        }
      }
    }
    .main-prodserv {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .prod {
        cursor: pointer;
        background-color: #fafafa;
        margin: 5vh 0;
        border: 1px solid #e4e4e4;
        height: 60vh;
        width: 30vh;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .prod-img {
          width: 100%;
          height: 30vh;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            height: 11vh;
            width: 10vh;
          }
        }
        .prod-name {
          width: 100%;
          height: 10vh;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
        .prod-desc {
          height: 30vh;
          padding: 1vw;
          font-size: 0.6rem;
          color: grey;
        }
      }
    }
    .main-cert {
      display: flex;
    }
    .main-patent {
      display: flex;
    }
    .main-book {
      display: flex;
      margin-top: 3vh;
      div {
        height: 40vh;
      }
      div:nth-child(n + 2) {
        margin: 0 0 0 -7vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main.vue